<template>
  <v-card outlined class="pa-4 rounded-lg h-100">
    <v-row dense>
      <v-col cols="12" sm="5">
        <h3 style="width: 100%" class="ml-2 my-2">
          <v-icon color="green" class="mr-1">mdi-thermometer-plus</v-icon>Acondicionamento de Tecido:
        </h3>
        <v-row dense>
          <v-col class="d-flex" cols="12">
            <v-checkbox
              v-for="item in fabricConditionings"
              :key="item.id"
              v-model="localSelected"
              :label="item.description"
              :value="item.id"
              color="success"
              hide-details
            />
          </v-col>

          <h4 style="width: 100%" class="ml-5 mb-4">
            Controle de Temperatura do Globo Enucleado:
          </h4>
          <v-row dense class="ml-4 mr-5 mb-2" style="width: 100%">
            <v-col cols="12">
              <v-text-field
                data-cy="hora-saida"
                v-model="fabricConditioning.temperature_date_and_time_saida"
                type="datetime-local"
                :rules="formRules"
                persistent-hint
                color="#086318"
                class="rounded-lg"
                dense
                outlined
              >
                <template v-slot:label>
                  Data de Saída e Hora<span style="color: red">*</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                data-cy="temperatura"
                v-model="fabricConditioning.current_temperature_saida"
                persistent-hint
                suffix="ºC"
                :rules="formRules"
                type="number"
                color="#086318"
                class="rounded-lg"
                dense
                outlined
              >
                <template v-slot:label>
                  Temperatura do Momento<span style="color: red">*</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row dense class="ml-2" style="width: 100%" v-if="profile == 'tec_banco_olhos'">
            <v-col cols="12" sm="2">
              <v-text-field
                v-model="fabricConditioning.temperature_date_and_time_chegada"
                type="datetime-local"
                persistent-hint
                color="#086318"
                class="rounded-lg"
                dense
                outlined
              >
                <template v-slot:label>Data de chegada e hora</template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-text-field
                v-model="fabricConditioning.current_temperature_chegada"
                persistent-hint
                color="#086318"
                class="rounded-lg"
                :rules="formRules"
                suffix="ºC"
                dense
                outlined
              >
                <template v-slot:label>Temperatura do Momento</template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-row>
      </v-col>

      <v-divider vertical></v-divider>

      <v-col cols="12" sm="7">
        <v-row dense class="pa-2">
          <h3 style="width: 100%" class="ml-2 my-2">
            <v-icon color="green" class="mr-1">mdi-water</v-icon>Coleta de Amostra Sanguínea:
          </h3>

          <v-col cols="12">
            <v-select
              data-cy="coleta"
              class="rounded-lg"
              color="#086318"
              v-model="bloodCollection.blood_sample_collection_id"
              :items="bloodSampleCollections"
              :rules="formRules"
              item-text="description"
              item-value="id"
              dense
              outlined
            >
              <template v-slot:label>
                Local da Coleta: <span style="color: red">*</span>
              </template>
            </v-select>
          </v-col>

          <v-col class="d-flex" cols="12" v-if="bloodCollection.blood_sample_collection_id == 6">
            <v-text-field
              class="rounded-lg"
              color="#086318"
              v-model="bloodCollection.description"
              :rules="formRules"
              dense
              outlined
            >
              <template v-slot:label>
                Especifique: <span style="color: red">*</span>
              </template>
            </v-text-field>
          </v-col>

          <v-col class="d-flex" cols="12">
            <v-text-field
              data-cy="calibre"
              class="rounded-lg"
              color="#086318"
              v-model="bloodCollection.needle_gauge"
              :rules="formRules" 
              dense
              outlined
            >
              <template v-slot:label>
                Calibre da Agulha: <span style="color: red">*</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    fabricConditioning: { type: Object, required: true },
    fabricConditionings: { type: Array, default: () => [] },
    selectedFabricConditionings: { type: Array, default: () => [] },
    bloodCollection: { type: Object, required: true },
    bloodSampleCollections: { type: Array, default: () => [] },
    profile: { type: String, default: '' },
    formRules: { type: Array, default: () => [] }, 
  },

  computed: {
    localSelected: {
      get() { return this.selectedFabricConditionings; },
      set(val) { this.$emit('update:selectedFabricConditionings', val); },
    },
  },
};
</script>
